<template>
  <div class="detail">
    <!--项目详情-->
    <div class="order__itemBox mb_10">
      <div class="storeList flex_center radius5">
        <div class="storeList__img itemList__img"><img :src="order_data.service_thumb" alt=""></div>
        <div class="storeList__content">
          <div>{{order_data.servicetitle}}</div>
          <div class="col_999 fs_12 mb_5 one">{{order_data.service_desc}}</div>
          <div class="itemList_price fs_12"><span>¥{{order_data.service_price}}</span>{{order_data.service_itemtime}}分钟/次</div>
        </div>
      </div>
    </div>

  <div class="order_info">
      <p><label>订单编号：</label><span>{{order_data.ordersn}}</span></p>
      <p><label>下单时间：</label><span>{{order_data.createtime}}</span></p>
      <p><label>订单金额：</label><span class="col_E97620">{{order_data.price}}</span></p>
      <p><label>订单状态：</label>
      <span v-if="tech_order_item.status==0">待接单</span>
      <span v-if="tech_order_item.status==1">已接单</span>
      <span v-if="tech_order_item.status==2">已拒绝</span>
      <span v-if="tech_order_item.status==3">服务中</span>
      <span v-if="tech_order_item.status==4">已完成</span>
      <span v-if="tech_order_item.status==5">用户取消</span>
      </p>
      <div v-for="(tech_item1,tech_index1) in tech" :key="tech_index1">
          <p v-if="tech_item1.service_status==4"><label>核销时间：</label><span >{{tech_item1.finishtime}}</span></p>
          <p v-if="tech_item1.service_status==4"><label>核销人员：</label><span>{{tech_item1.name}}</span></p>
      </div>
      
      <p v-if="order_data.status !=3"><label>{{order_data.distance_text}}</label><span >{{order_data.distance_service}}</span></p>

    </div>

    <div class="order_info">
      <ul class="store_box">
        <li class>
          <span>服务门店:</span>
          <span>{{store.storename}}</span>
        </li>

        <li class>
          <span>服务人数:</span>
          <span>{{order_data.total}}位</span>
        </li>

        <!-- <li class>
          <span>服务床位:</span>
          <span>1号床位</span>
        </li> -->

        <li class  v-for="(tech_item,tech_index) in tech" :key="tech_index" >
          <span>服务技师:</span>
          <span style="color: #969799;">{{tech_item.name}}</span>
           <a v-if="tech_item.refuse==2" class="tech_none" style="color: #969799;">（拒绝接单）</a>
        </li>

        <li class>
          <span>服务时间:</span>
          <span>{{order_data.starttime}}</span>
        </li>

        <li class>
          <span>联系人:</span>
          <span>{{order_data.realname}}</span>
        </li>

        <li class>
          <span>手机号:</span>
          <span>{{order_data.mobile}}</span>
        </li>
      </ul>

      <div class="btn_box" v-if="tech_order_item.status == 0&&tech_order_item.is_cancel==1">
        <button class="cancel_btn" @click="cancel">取消订单</button>
        <button class="pay_btn" @click="check_order()">确认接单</button>
      </div>
      <div class="btn_box" v-if="tech_order_item.status == 1">
        <button class="pay_btn" @click="begin_order()">开始服务</button>
      </div>
    </div>

    <van-popup v-model="cancelrs_show" closeable position="bottom" class="popup">
      <p class="cancel_label">取消订单</p>
      <div class="time_tip flex_center">
        <span class="iconfont icon-tishi"></span> 顾客付款30分钟内可取消订单
      </div>

      <p class="respon_label">请选择取消订单原因</p>

      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell title="时间冲突" clickable @click="radio = '0'">
            <van-radio slot="right-icon" name="0" />
          </van-cell>
          <van-cell title="不想服务了" clickable @click="radio = '1'">
            <van-radio slot="right-icon" name="1" />
          </van-cell>
          <van-cell title="其他原因" clickable @click="radio = '2'">
            <van-radio slot="right-icon" name="2" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <div class="other" v-if="radio==2">
        <!-- <input type="text" /> -->
        <textarea v-model="refuse"></textarea>
      </div>

      <div class="btn_box">
        <button class="ckcancel_btn" @click="cancel_order()">确认取消</button>
      </div>
    </van-popup>
    
  </div>
</template>

<script>
export default {
  name: "tech_detail",
  components: {},
  data() {
    return {
      cancelrs_show: 0,
      radio: "0",
      //项目列表
      itemList: [
      ],
      order_id: 0,
      order_data:[],
      store:[],
      tech:[],
      order_item:[],
      refuse:"",
      tech_order_item:[]
    };
  },
  created() {
    this.order_id = this.$route.query.order_id;
    if (this.order_id == 0) {
      this.$toast({
        message: '订单信息错误,请联系商家处理',
        onClose: () => {
          this.$router.go(-1);
        }
      });
    }
    this.get_order();
  },
  methods: {
    get_order() {
      this.axios({
        url: this.api.tech.tech_order_detail,
        data: {order_id: this.order_id }
      }).then(res => {
        if (res.error === 0) {
           this.order_data = res.order
           this.store = res.store
           this.tech = res.tech
           this.order_item = res.order_item
           this.tech_order_item = res.tech_order_item
        }
      });
    },
     begin_order(){
      this.axios({
        url: this.api.tech.tech_begin_order, //获取用户信息
        data: {order_id:this.order_id }
      }).then(res => {
        if (res.error === 0) {
          location.reload();
        }
      });
    },
    cancel() {
      this.cancelrs_show = 1;
    },
    cancel_order(){
      this.axios({
        url: this.api.tech.tech_cancel_order,
        data: {
          order_id: this.order_id,
          radio:this.radio,
          refuse:this.refuse
         }
      }).then(res => {
        if (res.error == 0) {
          this.$toast({
            message:"取消接单成功",
            duration:1000,
            onClose:function(){
            //  this.get_order();
            location.reload(); 
            }
          });
        }
      });
    },
    check_order(){
      this.axios({
        url: this.api.tech.tech_check_order,
        data: {order_id: this.order_id }
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            message:"确认订单成功",
            duration:1000,
            onClose:function(){
            location.reload();
            }
          });
        }
      });
    }
  }
};
</script>
<style scoped>
@import "../../../assets/css/store.css"; /*门店样式*/
@import "../../../assets/css/item.css"; /*服务项目*/
.order__itemBox {
  background: #45b9bc;
  padding: 0.75rem 0.5rem;
}
.storeList {
  margin-bottom: 0;
}

.order_info {
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.7rem;
  color: #4b4d4d;
  background-color: white;
}
.order_info span:last-child {
  color: #929393;
}
.order_info p{
      margin: 10px 0px;
}
.order_info li {
  padding: 0.25rem 0;
}
.order_info li span:first-child {
  width: 25%;
  display: block;
  float: left;
}
.order_info li span:last-child {
  width: 100%;
  display: block;
}
.col_E97620 {
  color: #e97620 !important;
}
.store_box {
  padding-bottom: 1.25rem;
}
.btn_box {
  margin: 2rem 0;
  text-align: center;
}
.cancel_btn {
  border-radius: 5px;
  border: 1px solid #a0a0a0;
  font-size: 0.8rem;
  color: #7b7979;
  padding: 0.5rem 1.3rem;
  margin: 0 0.5rem;
}
.pay_btn {
  border-radius: 5px;
  border: 1px solid #45b9bc;
  font-size: 0.8rem;
  color: #45b9bc;
  padding: 0.5rem 1.3rem;
  margin: 0 0.5rem;
}
.cancel_label {
  padding: 1rem 0;
  font-size: 0.9rem;
  color: #434343;
  text-align: center;
}
.time_tip {
  background-color: #effbfb;
  color: #45b9bc;
  font-size: 0.6rem;
  padding: 0.25rem 0.75rem;
}
.icon-tishi {
  padding-top: 0.2rem;
}
.respon_label {
  font-size: 0.7rem;
  color: #989696;
  padding: 1rem 0.75rem 0.5rem;
}
.other {
  margin: 0.5rem 0.75rem;
  border: 1px solid #eee;
}
.other input {
  width: 100%;
  font-size: 0.75rem;
}
.van-radio-group {
  padding: 0 0.75rem;
  font-size: 0.7rem;
  color: #595757;
}
.van-radio__icon {
  height: 1rem;
}
.ckcancel_btn {
  background-color: #45b9bc;
  color: white;
  border-radius: 4px;
  padding: 0.5rem 0;
  width: 70%;
}
.col_5E5E5E {
  color: #5e5e5e !important;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/order/tech_detail.vue